export default "__VITE_ASSET__25fe4db3__"